import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, Row, Col, message, Spin } from "antd";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions";
import Endpoints from "../../../api/endpoints";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const BillingInformation = ({
  initialValues,
  isLoading,
  shopId,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const axiosPrivate = useAxiosPrivate();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  useEffect(() => {
    if (initialValues) {
      const formValues = {
        companyTitle: initialValues.companyTitle || "",
        taxOffice: initialValues.taxOffice || "",
        taxNo: initialValues.taxNo || "",
        address: initialValues.address || "",
      };
      form.setFieldsValue(formValues);
    }
  }, [initialValues, form]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    setIsSubmitLoading(true);
    const requestBody = {
      shopId: shopId,
      ...values,
    };
    const response = await EndpointFunctions.putData({
      endpointURL: Endpoints.updateShopBillingInfo,
      axiosPrivate: axiosPrivate,
      data: requestBody,
    });
    if (response.success) {
      message.success("Fatura bilgileri güncellendi");
      if (onSuccess) {
        onSuccess();
      }
    } else {
      message.error("Fatura bilgileri güncellenemedi");
    }
    setIsSubmitLoading(false);
  };

  return (
    <Spin spinning={isSubmitLoading}>
      <Card
        style={{ marginTop: 16 }}
        title="Fatura Bilgileri"
        type="inner"
        extra={
          <Button type="primary" onClick={handleSubmit} loading={isLoading}>
            Kaydet
          </Button>
        }>
        <Form form={form} layout="vertical">
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item name="companyTitle" label="Şirket Ünvanı">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="taxOffice" label="Vergi Dairesi">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="taxNo" label="Vergi Numarası">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="address" label="Fatura Adresi">
                <Input.TextArea />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Spin>
  );
};

export default BillingInformation;
